// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".cleaner-object-info {\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n}\n.cleaner-object-info span:first-child {\n  padding-right: 3px;\n}\n.cleaner-object-info .ant-btn {\n  height: 22px !important;\n  border-radius: 1px !important;\n  padding-left: 5px;\n  padding-right: 5px;\n}\n", ""]);
// Exports
module.exports = exports;
